import { Component, inject, type OnDestroy } from '@angular/core';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { SortPipe } from '@core';
import { MultipleSelectComponent, SearchInputComponent } from '@ui';

import { BuildingDataFilterService } from '../../../services/building-data-filter.service';

@Component({
  imports: [
    MatButtonToggleGroup,
    MatButtonToggle,
    SearchInputComponent,
    MatIcon,
    MatOption,
    MatSelectModule,
    MatSuffix,
    MatFormField,
    MultipleSelectComponent,
    MatButton,
    SortPipe,
],
  selector: 'app-site-table-desktop-filters',
  templateUrl: './site-table-desktop-filters.component.html',
})
export class SiteTableDesktopFiltersComponent implements OnDestroy {
  buildingDataFilterService = inject(BuildingDataFilterService);


  get selectedFilters(): boolean {
    return !!(this.buildingDataFilterService.statusFilter || this.buildingDataFilterService.incidentFilter?.length);
  }

  clearAllFilters() {
    this.buildingDataFilterService.statusFilter = '';
    this.buildingDataFilterService.incidentFilter = [];
  }

  ngOnDestroy() {
    this.buildingDataFilterService.clearFilters();
  }
}
